<template style="height: 100%">
	<div class="Evaluation_statistics">
		<el-form style="background: #fff; height: 60px; padding-top: 20px" :inline="true" class="demo-form-inline">
			<el-form-item label="开始时间" style="margin-left: 20px">
				<el-date-picker value-format="yyyy-MM-dd" v-model="censusparams.from" type="date" placeholder="选择日期"></el-date-picker>
			</el-form-item>
			<el-form-item label="结束时间" style="margin-left: 20px">
				<el-date-picker value-format="yyyy-MM-dd" v-model="censusparams.to" type="date" placeholder="选择日期"></el-date-picker>
			</el-form-item>
			<el-form-item>
				<el-button type="primary" @click="onSubmit(1)">查询</el-button>
				<el-button type="primary" @click="onSubmit(2)">重置</el-button>
			</el-form-item>
		</el-form>

		<div style="width: 100%; height: calc(100% - 95px); background: #fff; margin-top: 15px; overflow: auto">
			<h3 style="padding: 10px 20px">一、部门</h3>
			<el-table v-loading="loadings" :data="tablbm" style="width: 98%; margin-left: 1%; padding-top: 15px">
				<el-table-column label="单位编号">
					<template slot-scope="scope">
						<span>{{ scope.row.deptID }}</span>
					</template>
				</el-table-column>
				<el-table-column label="培养单位">
					<template slot-scope="scope">
						<span>{{ scope.row.deptName }}</span>
					</template>
				</el-table-column>
				<el-table-column label="联系人">
					<template slot-scope="scope">
						<span>{{ scope.row.contactName }}</span>
					</template>
				</el-table-column>
				<el-table-column label="联系电话">
					<template slot-scope="scope">
						<span>{{ scope.row.contactPhone }}</span>
					</template>
				</el-table-column>
				<el-table-column label="总人数">
					<template slot-scope="scope">
						<span>{{ scope.row.totalQnty }}</span>
					</template>
				</el-table-column>
				<el-table-column label="红色人数">
					<template slot-scope="scope">
						<span>{{ scope.row.redQnty }}</span>
					</template>
				</el-table-column>
				<el-table-column label="橙色人数">
					<template slot-scope="scope">
						<span>{{ scope.row.orangeQnty }}</span>
					</template>
				</el-table-column>
				<el-table-column label="黄色人数">
					<template slot-scope="scope">
						<span>{{ scope.row.yellowQnty }}</span>
					</template>
				</el-table-column>
				<el-table-column label="红色人数占比">
					<template slot-scope="scope">
						<span>{{ scope.row.redrate }}</span>
					</template>
				</el-table-column>
				<el-table-column label="橙色人数占比">
					<template slot-scope="scope">
						<span>{{ scope.row.orangerate }}</span>
					</template>
				</el-table-column>
				<el-table-column label="黄色人数占比">
					<template slot-scope="scope">
						<span>{{ scope.row.yellowrate }}</span>
					</template>
				</el-table-column>
			</el-table>

			<h3 style="padding: 10px 20px">二、当事人类别</h3>
			<el-table v-loading="loadings" :data="tableData.degreeList" style="width: 98%; margin-left: 1%; padding-top: 15px" row-key="role" default-expand-all :tree-props="{ children: 'subList' }">
				<el-table-column label="分类">
					<template slot-scope="scope">
						<span>{{ scope.row.role }}</span>
					</template>
				</el-table-column>
				<el-table-column label="黄色人数">
					<template slot-scope="scope">
						<span>{{ scope.row.zhongdu }}</span>
					</template>
				</el-table-column>
				<el-table-column label="橙色人数">
					<template slot-scope="scope">
						<span>{{ scope.row.jiaozhong }}</span>
					</template>
				</el-table-column>
				<el-table-column label="红色人数">
					<template slot-scope="scope">
						<span>{{ scope.row.yanzhong }}</span>
					</template>
				</el-table-column>
				<el-table-column label="合计">
					<template slot-scope="scope">
						<span>{{ scope.row.total }}</span>
					</template>
				</el-table-column>
			</el-table>
			<h3 style="padding: 10px 20px">三、月度干预次数</h3>
			<el-table v-loading="loadings" :data="tableData.monthList" style="width: 98%; margin-left: 1%; padding-top: 15px">
				<el-table-column label="分类">
					<template slot-scope="scope">
						<span>{{ scope.row.month }}</span>
					</template>
				</el-table-column>
				<el-table-column label="黄色人数">
					<template slot-scope="scope">
						<span>{{ scope.row.zhongdu }}</span>
					</template>
				</el-table-column>
				<el-table-column label="橙色人数">
					<template slot-scope="scope">
						<span>{{ scope.row.jiaozhong }}</span>
					</template>
				</el-table-column>
				<el-table-column label="红色人数">
					<template slot-scope="scope">
						<span>{{ scope.row.yanzhong }}</span>
					</template>
				</el-table-column>
				<el-table-column label="合计">
					<template slot-scope="scope">
						<span>{{ scope.row.total }}</span>
					</template>
				</el-table-column>
			</el-table>
			<h3 style="padding: 10px 20px">四、获悉来源</h3>
			<el-table v-loading="loadings" :data="tableData.sourceList" style="width: 98%; margin-left: 1%; padding-top: 15px" row-key="source" default-expand-all :tree-props="{ children: 'subList' }">
				<el-table-column label="分类">
					<template slot-scope="scope">
						<span>{{ scope.row.source }}</span>
					</template>
				</el-table-column>
				<el-table-column label="黄色人数">
					<template slot-scope="scope">
						<span>{{ scope.row.zhongdu }}</span>
					</template>
				</el-table-column>
				<el-table-column label="橙色人数">
					<template slot-scope="scope">
						<span>{{ scope.row.yanzhong }}</span>
					</template>
				</el-table-column>
				<el-table-column label="红色人数">
					<template slot-scope="scope">
						<span>{{ scope.row.yanzhongqiejinji }}</span>
					</template>
				</el-table-column>
				<el-table-column label="合计">
					<template slot-scope="scope">
						<span>{{ scope.row.total }}</span>
					</template>
				</el-table-column>
			</el-table>
			<h3 style="padding: 10px 20px">五、自杀风险</h3>
			<el-table v-loading="loadings" :data="suicide" style="width: 98%; margin-left: 1%; padding-top: 15px">
				<el-table-column label="自杀想法">
					<template slot-scope="scope">
						<span>{{ scope.row.zishaxiangfa }}</span>
					</template>
				</el-table-column>
				<el-table-column label="自杀计划">
					<template slot-scope="scope">
						<span>{{ scope.row.zishajihua }}</span>
					</template>
				</el-table-column>
				<el-table-column label="自杀姿态">
					<template slot-scope="scope">
						<span>{{ scope.row.zishazitai }}</span>
					</template>
				</el-table-column>
				<el-table-column label="自杀未遂">
					<template slot-scope="scope">
						<span>{{ scope.row.zishaweisui }}</span>
					</template>
				</el-table-column>

				<el-table-column label="自杀死亡">
					<template slot-scope="scope">
						<span>{{ scope.row.zishasiwang }}</span>
					</template>
				</el-table-column>

				<el-table-column label="共计">
					<template slot-scope="scope">
						<span>{{ scope.row.total }}</span>
					</template>
				</el-table-column>
			</el-table>
		</div>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				censusparams: {
					from: '2024-01-01',
					to: '2024-06-30',
				},
				loadings: false,
				tableData: [],
				suicide: [],
				tablbm: [],
			};
		},
		methods: {
			// 方法1：直接排序（推荐）
			customSort(data) {
				// 主排序规则
				const mainOrder = ['学生', '教职工', '不详', '合计'];

				// 子排序规则
				const subOrder = ['博士生', '硕士生', '本科生'];

				return data
					.sort((a, b) => mainOrder.indexOf(a.role) - mainOrder.indexOf(b.role))
					.map((item) => {
						if (item.role === '学生' && item.subList) {
							return {
								...item,
								subList: item.subList.sort((a, b) => subOrder.indexOf(a.role) - subOrder.indexOf(b.role)),
							};
						}
						return item;
					});
			},

			onSubmit(type) {
				if (type !== 1) {
					this.censusparams.from = this.Global.querycensus(12)[0];
					this.censusparams.to = this.Global.querycensus(12)[1];
				}
				this.loading();
			},

			loading() {
				this.loadings = true;
				this.$Http_Post('management/distressPrediction/crisisReportData', this.censusparams).then((res) => {
					if (res.Code == 200 || res.Code == 0) {
						this.loadings = false;
						this.tableData = res.Data;
						this.suicide = res.Data.suicideList;
						this.customSort(this.tableData.degreeList);
					}
				});

				this.$Http_Post('crisisStatistics/crisisStatisticsByUnit', { pageSize: '10', pageIndex: '1', deptName: '', deptID: '', excelFlag: '2', month: this.censusparams.to }).then((res) => {
					if (res.Code == 200 || res.Code == 0) {
						this.tablbm = res.Data;
					}
				});
			},
		},
		mounted() {
			this.censusparams.from = this.Global.querycensus(12)[0];
			this.censusparams.to = this.Global.querycensus(12)[1];
			this.loading();
		},
	};
</script>
<style>
	.Evaluation_statistics {
		height: 100%;
		overflow: auto;
	}
</style>
